<template>
  <BootstrapDropdown id="settings.profile-dropdown">
    <template #toggle>
      <BootstrapButton
        id="settings-menu-btn"
        name="Open Settings"
        variant="ghost"
        class="btn-profile"
        :aria-label="translate('Open Settings Menu')"
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside"
      >
        <div class="d-flex flex-nowrap align-items-center gap-1">
          <div v-if="!isMobile && !isTablet" class="d-flex flex-column flex-nowrap text-end me-1">
            <h6>{{ selected?.name }}</h6>
            <p>{{ userStore.user?.email }}</p>
          </div>
          <Icon icon="material-symbols:account-circle-outline" class="flex-shrink-0 fs-5" />
        </div>
      </BootstrapButton>
    </template>
    <template #items>
      <div class="px-2" style="min-width: 20rem">
        <div class="d-flex flex-row gap-1 p-1">
          <Icon icon="material-symbols:account-circle" class="fs-1 mt-2" />
          <div class="d-flex flex-column m-1 mx-2">
            <strong>{{ userStore.user?.first_name + ' ' + userStore.user?.last_name }}</strong>
            <small>{{ userStore.user?.email }}</small>
          </div>
        </div>
        <div class="d-flex flex-column gap-1 p-1">
          <SearchComboBox
            v-if="options.length !== 1"
            id="settings.customer"
            v-model="selected"
            :options="options"
            :api-read-module="apiGetCustomers"
            :store-set-action="customersStore.setCustomers"
            :disabled="options.length === 1"
            :error="errorMessage"
            custom-key="name"
            size="sm"
            class="mb-2"
          />
          <BootstrapButton
            id="settings.open"
            name="Open Settings"
            variant="ghost"
            size="sm"
            @click="$emit('open')"
          >
            <Icon icon="material-symbols:settings-outline" class="me-1" />
            {{ translate('Settings') }}
          </BootstrapButton>
          <BootstrapButton
            id="settings.log-out"
            name="Log out"
            class="text-danger"
            variant="ghost"
            size="sm"
            @click="logout"
          >
            <Icon icon="material-symbols:logout" class="me-1" />
            {{ translate('Log out') }}
          </BootstrapButton>
        </div>
      </div>
    </template>
  </BootstrapDropdown>
</template>
<script lang="ts" setup>
import {logoutKey} from '@/App.vue';
import {useGuidedTours} from '@/composables/guidedTours/useGuidedTours';

const {useTourRegistration} = useGuidedTours();
useTourRegistration('user-invitation');

const logout = inject(logoutKey);
const router = useRouter();
defineEmits<{open: []; logout: []}>();

const {translate} = useLocalisation();
const storage = useLocalStorage();
const userStore = useUserStore();
const customersStore = useCustomersStore();
const {isMobile, isTablet} = useBsBreakpoints();

const selected = computed({
  get: () =>
    customersStore.selectedCustomer !== null ? customersStore.selectedCustomer.customer : null,
  set: (value: Customer) => {
    if (value.id !== customersStore.selectedCustomer?.customer.id) readCustomerById(value);
  },
});
const options = computed(() => customersStore.customers || []);

const loading = ref(false);
const errorMessage = ref('');

const readCustomerById = async (customer: Customer) => {
  loading.value = true;
  try {
    await customersStore.readCustomerById(customer.id);
    storage.removeItem('sphere-pages');
    router.go(0);
  } catch (error: any) {
    errorMessage.value = String(error);
  } finally {
    loading.value = false;
  }
};
</script>
<style lang="scss" scoped>
@import '@/scss/ekco';

.btn-profile {
  /* Match icon buttons in header */
  padding: $btn-padding-y $btn-padding-y;
  cursor: pointer;

  h6 {
    font-weight: bolder;
    line-height: 1;
  }

  h6,
  p {
    text-wrap: nowrap;
    margin: 0;
    font-size: 0.75rem;
  }
}
</style>
